import { render, staticRenderFns } from "./EmbryoStockPage.vue?vue&type=template&id=5f405b21&scoped=true&"
import script from "./EmbryoStockPage.vue?vue&type=script&lang=js&"
export * from "./EmbryoStockPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f405b21",
  null
  
)

export default component.exports